/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Button, ButtonSize, ButtonVariant, MITheme } from "@spectrumselect/mi-ui-react"
import { OtpInputFormReduxProps, updateStandardFormErrorMessage } from "../../redux/AppStateSlice";
import { S } from "../../auth/sdk";
import { ErrorMessage } from "../../components/errorMessage/ErrorMessage";
import PassInput from "../../components/shared/PasswordInput/PasswordInput";
import { MAILTO } from "../../utils/constants";
import "./OTPInputForm.scss";

export interface OTPInputFormProps extends OtpInputFormReduxProps {
    errorMessage?: string;
    tenant?: string;
}

export const OTPInputForm: React.FunctionComponent<OTPInputFormProps> = (props) => {
    const [otp, setOtp] = useState("");
    const answerInputRef = useRef<HTMLInputElement>(null);
    const dispatch = useDispatch()

    useEffect(() => {
        if (props.errorMessage) {
            setOtp("");//clear input on new error
            answerInputRef.current?.focus();
        }
    }, [props.errorMessage])

    const onCancelButtonClick = () => {
       // event.preventDefault();
        props.resolve(S.InputOrControlResponse.createControlResponse(S.ControlRequest.create(S.ControlRequestType.CancelAuthenticator)))
    }

    const onSubmitButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        dispatch(updateStandardFormErrorMessage("")) //clear errorMessage
        props.resolve(S.InputOrControlResponse.createInputResponse(S.TargetBasedAuthenticatorInput.createAuthenticatorInput(S.OtpInputOtpSubmission.createOtpSubmission(otp))));
    }

    return (
        <form className={"OTPInputForm"}>
            <h1 className="App_pageTitle">Additional verification required</h1>
            {!!props.errorMessage && <ErrorMessage>{props.errorMessage}</ErrorMessage>}
            <div className="SendOTPForm_DescriptionWrapper">
                <p className="App_formDesc SendOTPForm_formDesc">For your security, we need to verify your identity. </p>
                <p className="App_formDesc SendOTPForm_formDesc">
                    We’ve sent an email to your account. This may take a moment.
                </p>
                <p className="App_formDesc SendOTPForm_formDesc">
                    Enter the code below to continue.
                </p>
            </div>
            <div className="App_formInputGroup otp-input">
                <PassInput
                    ref={answerInputRef}
                    className="input100"
                    id="otp"
                    placeholder="Verification Code"
                    label=""
                    value={otp}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => setOtp(event.target.value)}
                />
            </div>

            <div className="App_formButtonGroup">
                <Button
                    variant={ButtonVariant.primary}
                    type="submit"
                    className={`login100-form-btn ${props.tenant}-btn otp-btn`}
                    disabled={otp.length === 0}
                    onClick={onSubmitButtonClick}
                    theme={MITheme.dark}
                    size={ButtonSize.large}
                >
                Next
                </Button>
                <a href="javascript:void(0)" className={`UsernameForm_ResetPwdButton ${props.tenant}-text`} onClick={onCancelButtonClick}>
                    Sign into a different account
                </a>
                <a href="javascript:void(0)" className={`UsernameForm_ResetPwdButton ${props.tenant}-text`} onClick={props.onResendButtonClick}>
                    Resend email
                </a>
            </div>
            <p className="txt2 welcome-desc">Need more help logging in? Please contact our Onboarding Team <span>(<a href={MAILTO.link}>{MAILTO.text}</a>)</span>.</p>
        </form>
    )
}
